import { render, staticRenderFns } from "./Certificacoes.vue?vue&type=template&id=54a1b17c&scoped=true&lang=pug"
import script from "./Certificacoes.vue?vue&type=script&lang=js"
export * from "./Certificacoes.vue?vue&type=script&lang=js"
import style0 from "./Certificacoes.styl?vue&type=style&index=0&id=54a1b17c&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a1b17c",
  null
  
)

export default component.exports